import React from 'react'
import CrumplePopLoginSelect from './CrumplePopLoginSelect'
import CrumplePopEmailSignin from './CrumplePopEmailSignin'
import CrumplePopSignup from './CrumplePopSignup'
import SpinnerOverlay from '../../../common/components/SpinnerOverlay'
import { CrumplePopSignupContext } from '../../contexts/CrumplePopSignupContext'

import { axiosGet, axiosPost } from '../../../common/js/axios-utility'

export default function CrumplePopLoginPanel({onComplete}) {
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);
    const {loginPage} = migrationState;

    const [userEmail, setUserEmail] = React.useState('');

    let content = <></>

    const handleEmailEntry = (email) => {
        setUserEmail(email);
        setMigrationState({...migrationState, processing: false, loginPage: 'password'});
    }

    const handleGoogleSignin = async (data) => {
        completeSignIn(data);
    }

    const handleFacebookSignin = async (data) => {
        completeSignIn(data);
    }

    const handleEmailSignin = (data) => {
       completeSignIn(data);
    }

    const completeSignIn = async (data) => {
        onComplete(data);
    }

    if (loginPage == 'select'){
        content = <CrumplePopLoginSelect 
                    onEmailEntry={handleEmailEntry} 
                    onGoogleSignin={handleGoogleSignin}
                    onFacebookSignin={handleFacebookSignin}
                    onEmailSignin={handleEmailSignin} />
    }
    else if (loginPage == 'password'){
        content = <CrumplePopEmailSignin email={userEmail} onComplete={handleEmailSignin} />
    }

    return (
        <SpinnerOverlay hidden={!migrationState.processing} size={72}>
            <div className='cpop-login-panel'>
                <div className='cpop-logo-container'>
                    <img className='cpop-logo' src="https://borisfx-com-res.cloudinary.com/image/upload/v1697125297/Marketing/Website2024/Icons_SVG/CrumplePop2023/LightBkg/Crumplepop2023_Icon_LightBkg.svg" />
                    <h4 className='cpop-logo-header'>CrumplePop</h4>
                </div>
                <p>Let’s move your CrumplePop account to Boris FX. It’s quick and easy. 
                    First, sign in to your CrumplePop account.</p>
                {content}
            </div>
        </SpinnerOverlay>
    )
}
